"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmCardBlog = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useCard_1 = require("./useCard");
exports.SmCardBlog = (0, react_1.forwardRef)((_a, ref) => {
    var { size, brand, title, caption, content, prefixIcon, imageURL, imageALT, components, disabled, className, onClick } = _a, props = __rest(_a, ["size", "brand", "title", "caption", "content", "prefixIcon", "imageURL", "imageALT", "components", "disabled", "className", "onClick"]);
    const { headerElement, bodyContent, imageContent } = (0, useCard_1.useCard)(components, title, caption, content, imageURL, imageALT);
    const cardClassnames = (0, classnames_1.default)('c-card-blog', {
        '-disabled': disabled,
        '-interactive': onClick && !disabled,
        '-noImage': !(components === null || components === void 0 ? void 0 : components.image) && !imageURL,
    }, `-${brand}`, `-${size}`, className);
    return (react_1.default.createElement("article", Object.assign({}, props, { className: cardClassnames, 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: onclick ? 0 : -1, "aria-label": "article", role: "contentinfo", ref: ref }),
        imageContent(),
        react_1.default.createElement("section", { className: "c-card-blog__wrapper" },
            headerElement(),
            bodyContent(), components === null || components === void 0 ? void 0 :
            components.footer)));
});
//# sourceMappingURL=index.js.map